export default __webpack_public_path__ + "static/media/content-resize.8cbb354c.png";